module.exports = __webpack_public_path__ + "img/19.2d40ee4b.png";